export default __webpack_public_path__ + "static/media/resume_auto_overlay.3b13fa10.svg";